export const status = [
    'ongoing',
    'done',
];